module.exports = __webpack_public_path__ + "static/target-60f61b8e55a165778c32dea4a419bb45.svg";